module.exports = __webpack_public_path__ + "static/becoming-christmas-karen-d6f20c303de50173ec86c35a95ea55ca.jpg";